import React from 'react';
import { TextP, TextContainer } from './TextStyles';

function TextBody({text, cta}) {
    return (
        <TextContainer>
            <TextP dangerouslySetInnerHTML={{ __html: text }} />
            {cta}
        </TextContainer>
    )
}

export default TextBody;